export default __webpack_public_path__ + "static/media/verify-bg.27c4f6cd.svg";